import { SubmitHandler } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Form, useForm } from 'components/form'
import {
  CheckboxFormField,
  EmailFormField,
  FirstNameFormField,
  LastNameFormField,
  ZipCodeFormField,
} from 'components/form-field'
import { SubmitFormButton } from 'components/submit-form-button'
import { nest } from 'api'
import { ISubscribeFormData } from 'api/nest/home-sellers/types'

import { SUBSCRIBE_FIELDS_NAME, SUBSCRIBE_VALIDATOR } from './consts'
import classes from './subscribe-form.module.css'

export const SubscribeForm = () => {
  const formMethods = useForm(SUBSCRIBE_VALIDATOR, {
    reValidateMode: 'onSubmit',
  })

  const onSubmit: SubmitHandler<ISubscribeFormData> = async (data) => {
    await nest.homesellers.subscribe(data)
    toast.success('Your message has been sent!')
    formMethods.reset()
  }

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit} className={classes.form}>
      <EmailFormField
        className={classes.email}
        name={SUBSCRIBE_FIELDS_NAME.email}
        label={null}
        fullWidth
        placeholder="Email address"
      />
      <FirstNameFormField
        className={classes.fName}
        name={SUBSCRIBE_FIELDS_NAME.firstName}
        label={null}
        fullWidth
        placeholder="First name"
      />
      <LastNameFormField
        className={classes.lName}
        name={SUBSCRIBE_FIELDS_NAME.lastName}
        label={null}
        fullWidth
        placeholder="Last name"
      />
      <ZipCodeFormField
        className={classes.state}
        name={SUBSCRIBE_FIELDS_NAME.postalCode}
        label={null}
        fullWidth
        placeholder="Zip code"
      />
      <CheckboxFormField
        name={SUBSCRIBE_FIELDS_NAME.agreeEmailSubscription}
        className={classes.agree}
        verticalAlign="start"
      >
        I consent to receive occasional email communications from REZITRADE and acknowledge that I
        can unsubscribe at any time.
      </CheckboxFormField>
      <SubmitFormButton theme="primaryLight" className={classes.submit}>
        Subscribe
      </SubmitFormButton>
    </Form>
  )
}
